import type { RateOrInherit } from '@finsim/model';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../shared/lib/i18n/use-locale';
import { describeRate } from '../lib/describe-rate';

/** Short text for a rate: "3 %", "CPI + 2 %", "≈ 6 % ± 15 %", "Default". */
export function useDescribeRate(): (spec: RateOrInherit, inheritLabel?: string) => string {
  const { t } = useTranslation();
  const locale = useLocale();
  return (spec, inheritLabel) => describeRate(spec, t, locale, inheritLabel);
}
